import * as queryString from 'query-string';

const parseQueryParams = ({search}: any) => {
  return queryString.parse(search);
}

export { parseQueryParams };